import { AzavistaApiService, GroupedFieldsViewParentEntityType, GroupedFieldsViewParentType, IGroupedFieldsView } from '@azavista/servicelib';
import { IGroupedFieldsViewManager } from './interfaces';

export class ParentGroupedFieldsViewManager implements IGroupedFieldsViewManager {
    private parentType: GroupedFieldsViewParentType;
    private parentEntityId: string;
    private parentEntityType: GroupedFieldsViewParentEntityType;

    constructor(private apiSvc: AzavistaApiService) {
    }

    init(config: {
        parentType: GroupedFieldsViewParentType, parentEntityId: string, parentEntityType: GroupedFieldsViewParentEntityType
    }): void {
        this.parentType = config.parentType;
        this.parentEntityId = config.parentEntityId;
        this.parentEntityType = config.parentEntityType;
    }

    async getViews(): Promise<IGroupedFieldsView[]> {
        return await this.apiSvc.getParentViews(this.parentType, this.parentEntityId, this.parentEntityType);
    }

    async createView(view: IGroupedFieldsView): Promise<IGroupedFieldsView> {
        return await this.apiSvc.createParentView(this.parentType, this.parentEntityId, this.parentEntityType, view);
    }

    async updateView(view: IGroupedFieldsView): Promise<IGroupedFieldsView> {
        return await this.apiSvc.updateParentView(this.parentType, this.parentEntityId, this.parentEntityType, view);
    }

    async deleteView(viewId: string): Promise<void> {
        await this.apiSvc.deleteParentView(this.parentType, this.parentEntityId, this.parentEntityType, viewId);
    }
}
